export default __webpack_public_path__ + "static/media/WrapDirect.183d8b05.jpg";